// @flow
import React from 'react';
// Redux
import { connect } from 'react-redux';
// Selectors
import { userIdSelector } from '../../user/selectors';
import {
  orderNumberSelector,
  orderTokenSelector,
} from '../../current-order/selectors';
// Custom Hooks
import { useUtmManager } from '../customHooks/useUtmManager';
// Types
import type { Connector } from 'react-redux';

type Props = {
  userId: ?number,
  orderNumber: ?string,
  orderToken: ?string,
};

const UtmManager = ({ userId, orderNumber, orderToken }: Props) => {
  useUtmManager({ userId, orderNumber, orderToken, enabled: true });

  return null;
};

const mapStateToProps = (
  state,
): { userId: ?number, orderNumber: ?string, orderToken: ?string } => ({
  userId: userIdSelector(state),
  orderNumber: orderNumberSelector(state),
  orderToken: orderTokenSelector(state),
});

const connector: Connector<{}, Props> = connect(mapStateToProps);
export default connector(UtmManager);
